import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';
import { deriveProactiveAIApiUrl } from '../../prebuilt/utils';
export var getConfiguration = function getConfiguration(editorPluginAIProvider) {
  var proactiveAIConfig = editorPluginAIProvider.proactiveAIConfig,
    isFullPageExperimentsEnabled = editorPluginAIProvider.isFullPageExperimentsEnabled,
    allowProactiveAIFeatures = editorPluginAIProvider.allowProactiveAIFeatures;
  var isProactiveAISupported = !!isFullPageExperimentsEnabled && !!allowProactiveAIFeatures &&
  // NOTE: We need to ensure the experiment gate is evaluated last. This is beacuse if the product hasn't enabled
  // the feature then we don't want to hit the gate check since it's not possible for that product to have
  // the feature, and thus avoid an exposure from occuring.
  !!editorExperiment('editor_ai_-_proactive_ai_improve_writing', 'test', {
    exposure: true
  });
  return {
    isProactiveAISupported: isProactiveAISupported,
    proactiveAIConfig: _objectSpread(_objectSpread({}, proactiveAIConfig), {}, {
      enabled: isProactiveAISupported,
      defaultToggledState: false,
      apiUrl: deriveProactiveAIApiUrl(),
      timings: {
        // disabling the current chunk checking
        currentChunks: -1,
        currentChunksMaxWait: 30000,
        nonCurrentChunks: 5000
      },
      // We don't want a full page spell checker for this proative plugin
      documentSGChecker: undefined
    })
  };
};